<template>
  <div :class="['q-card-status-container',{ 'embedded':isEmbedded }]"
       :style="{ backgroundColor: backgroundColorL }"
       @click.stop="reLoad()">
    <div class="q-card-status-header">
      <b-button class="reload-button" rounded @click="reLoad()">
        <span class="mdi mdi-refresh icon-scale bigger"></span>
        อัพเดทคิว
      </b-button>
      <span :style="{fontSize:qStatusTitleFont}">สถานะคิว</span>
      <b-button class="reload-button" rounded @click.stop="reLoad()" :style="{fontSize:updateQFont}">
        <span class="mdi mdi-refresh icon-scale bigger" ></span>
        อัพเดทคิว
      </b-button>
    </div>
    <div class="q-card-status-body" :style="{fontSize:qStatusFont}">
      {{ caseMessage }}
    </div>
    <div class="q-card-status-footer" :style="{fontSize:qStatusFooterFont}">
      อัพเดทล่าสุด{{ showLatestUpdateTime }}
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { monthDigitToTHName } from '../utils/datetime'
import statusColorMixin from '../mixins/statusColor'

const props = {
  caseNumber: {
    type: Number,
    required: true
  },
  caseStatus: {
    type: String,
    required: true
  },
  caseMessage: {
    type: String,
    required: true
  },
  backgroundColor: {
    type: String,
    required: false
  },
  restartTime: {
    type: Boolean,
    required: false
  }
}

export default {
  name: 'qCardStatus',
  props,
  mixins: [statusColorMixin],
  mounted () {
    this.startCountUpdateTime()
    if (this.isEmbedded) {
      this.qStatusTitleFont = '2.5rem'
      this.updateQFont = '2rem'
      this.qStatusFont = '4rem'
      this.qStatusFooterFont = '2rem'
    }
  },
  data () {
    return {
      currentTime: null,
      latestUpdateTime: null,
      showLatestUpdateTime: '',
      updateTimeInterval: null,
      qStatusTitleFont: '',
      updateQFont: '',
      qStatusFont: '',
      qStatusFooterFont: '',
      isEmbedded: process.env.VUE_APP_EMBEDDED === 'true'
    }
  },
  methods: {
    startCountUpdateTime () {
      this.latestUpdateTime = moment()
      this.updateTimeInterval = setInterval(() => {
        this.currentTime = moment()
        const timeDuration = this.currentTime.diff(this.latestUpdateTime, 'minutes')
        if (timeDuration < 1) {
          this.showLatestUpdateTime = `ตอนนี้`
        } else if (timeDuration < 60) {
          this.showLatestUpdateTime = `เมื่อ ${timeDuration} นาทีที่แล้ว`
        } else if (timeDuration >= 60 && timeDuration < 24 * 60) {
          this.showLatestUpdateTime = `เมื่อ ${Math.floor(timeDuration / 60)} ชั่วโมงที่แล้ว`
        } else {
          this.showLatestUpdateTime = 'เมื่อ' + moment().format('DD-MM').split('-').map((t, i) => i === 1 ? monthDigitToTHName(t) : t).join(' ')
        }
      }, 1000)
    },
    reLoad () {
      this.$emit('reload', true)
      this.latestUpdateTime = moment()
    }
  },
  watch: {
    restartTime (newValue) {
      if (this.restartTime) {
        if (this.updateTimeInterval !== null) {
          clearInterval(this.updateTimeInterval)
        }
        this.startCountUpdateTime()
        this.restartTime = false
      }
    }
  },
  beforeDestroy () {
    if (this.updateTimeInterval !== null) {
      clearInterval(this.updateTimeInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
.q-card-status-container {
  margin: 1rem 1.375rem;
  padding: .25rem .5rem;
  border-radius: 16px;
  opacity: 0.8;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.16);

  &.embedded{
    border-radius:40px;
  }
  .q-card-status-header {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Mitr', sans-serif;
    font-size: .8125rem;

    button:first-child {
      margin-left: 0;
      margin-right: auto;
      visibility: hidden;
    }

    button:last-child {
      margin-left: auto;
    }

  }

  .reload-button {
    margin-left: auto;
    background: none;
    border: 1px solid #363636;
    padding: 4px 8px;
    font-family: 'Mitr', sans-serif;
    font-size: .75rem;
  }

  .q-card-status-body {
    font-family: 'Prajad', sans-serif;
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 1rem;
    margin-bottom: 1rem;
    text-align: center;
  }

  .q-card-status-footer {
    font-family: 'Mitr', sans-serif;
    font-weight: 300;
    font-size: .625rem;
    text-align: center;
  }
}
</style>
